import { startNavigation, completeNavigation } from 'app/stores/loadingStore';

/**
 * Tracks dynamic imports and updates loading state
 * @param importFn The dynamic import function
 * @returns A promise that resolves to the imported module
 */
export function trackImport<T>(importFn: () => Promise<T>): Promise<T> {
  // Start a navigation
  // console.log('Track import started - registering as a navigation');
  startNavigation();
  
  // Creating a promise to wrap the import
  return new Promise((resolve, reject) => {
    // Start the import
    importFn()    
      .then(module => {
        // console.log('Module loaded, completing navigation');

        // Mark this navigation as complete
        completeNavigation();
        
        // Resolve with the module
        resolve(module);
      })
      .catch(error => {
        // console.error('Import failed:', error);
        
        // Make sure to complete the navigation even on error
        completeNavigation();
        
        reject(error);
      });
  });
} 